<template>
  <div class="container">
    <h1 class="py-4">ポイント付与管理</h1>
    <h2>対象ユーザ抽出</h2>
    <p class="bottomborder">対象年月</p>
    <div class="form-row">
      <div class="form-group col-md-3">
        <input
          v-model="startDate"
          placeholder="開始月(YYYY/MM)"
          class="input-boot"
        />
      </div>
      <p class="pLineHeight">~</p>
      <div class="form-group col-md-3">
        <input
          v-model="endDate"
          placeholder="終了月(YYYY/MM)"
          class="input-boot"
        />
      </div>
    </div>
    <p class="txt-error" v-if="startDate == '' || endDate == ''">
      対象年月を入力してください
    </p>
    <p class="bottomborder">計算対象項目</p>
    <div class="form-row ml00">
      <div
        class="flex-row"
        v-for="(data, name, index) in this.transactionsFieldsMapping"
        :key="index"
      >
        <input
          v-model="conditionsArray"
          :id="data"
          :value="data"
          type="checkbox"
        />
        <label class="ml05 mr20" for="checkbox">{{ name }}</label>
      </div>
    </div>
    <p class="txt-error" v-if="conditionsArray.length == 0">
      計算対象項目を選択してください
    </p>
    <p class="bottomborder">対象金額</p>
    <div class="form-row">
      <div class="form-group col-md-3">
        <input v-model="amount" placeholder="円" class="input-boot" />
      </div>
      <p class="pLineHeight">円以上</p>
    </div>
    <p class="txt-error" v-if="amount == ''">
      対象金額を入力してください
    </p>
    <div class="pb-4">
      <div class="text-right">
        <button class="btn btn-primary" @click="search">
          ポイント付与ユーザ抽出
        </button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.usersCsv"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div>
      <div v-if="loading" class="form-row mb30">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="userTable"
          :items="users"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(契約番号)="data">
            <router-link
              :to="{
                name: 'ContractDetails',
                query: { contractId: data.item.契約番号 },
              }"
              >{{ data.item.契約番号 }}</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="userTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: "Points",
  mixins: [utils, master],
  computed: {
    rows() {
      return this.users.length;
    },
  },
  watch: {
    currentPage(value) {
      sessionStorage.currentPagePoints = value;
    },
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      conditionsArray: [],
      amount: "",
      csvCurrentFields: {
        contract_number: { title: "契約番号" },
        kana_name: { title: "カナ英字氏名" },
        kanji_name: { title: "漢字氏名" },
      },
      currentPage: 1,
      perPage: 10,
      fileName: "pointUsers",
      labels: [],
      loading: false,
      users: [],
      usersCache: [],
      appUserCache: [],
      paymentMethodCache: [],
      usersCsv: [],
      db: firebase.firestore(),
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    let minutes = 5;
    let saved = sessionStorage.getItem("saved");
    if (saved && new Date().getTime() - saved > minutes * 60 * 1000) {
      sessionStorage.clear();
    }
    let usersCacheSessionStorage = sessionStorage.getItem("usersCachePoints");
    if (
      usersCacheSessionStorage == null ||
      usersCacheSessionStorage.includes("null")
    ) {
      //this.loadCache();
    }
    let usersSessionStorage = sessionStorage.getItem("usersPoints");
    if (usersSessionStorage !== null) {
      this.currentPage =
        sessionStorage.currentPagePoints == null
          ? 1
          : sessionStorage.currentPagePoints;
      this.users = JSON.parse(usersSessionStorage);
      this.usersCsv = JSON.parse(sessionStorage.getItem("usersCsvPoints"));
      this.startDate =
        sessionStorage.startDate == null ? "" : sessionStorage.startDate;
      this.endDate =
        sessionStorage.endDate == null ? "" : sessionStorage.endDate;
      if (sessionStorage.getItem("conditions") !== null) {
        for (let condition of sessionStorage.getItem("conditions")) {
          this.conditionsArray.push(condition);
        }
      }
      this.conditionsArray =
        sessionStorage.getItem("conditions") == null
          ? []
          : JSON.parse(sessionStorage.getItem("conditions"));
      this.amount = sessionStorage.amount == null ? "" : sessionStorage.amount;
      this.loading = false;
    }
  },
  methods: {
    loadCache() {
      let query = this.db.collection("master");
      query.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          if (doc.exists) {
            var data = doc.data();
            this.usersCache[data.contract_number] = {
              contract_number: data.contract_number,
              representative_contract_number:
                data.representative_contract_number,
              telephone: data.telephone,
              mobile: data.mobile,
              kana_name: data.kana_name,
              kanji_name: data.kanji_name,
              valid_member_flag: data.valid_member_flag,
            };
          }
        });
      });
      /* .then(() => {
          sessionStorage.setItem(
            "usersCachePoints",
            JSON.stringify(this.usersCache)
          );
        }); */
      let queryPaymentData = this.db.collection("paymentMethod");
      queryPaymentData.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          let data = doc.data();
          this.paymentMethodCache[data.contract_number] =
            data.application_user_id;
        });
      });
      let queryAppUserData = this.db.collection("applicationUsers");
      queryAppUserData.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          let data = doc.data();
          this.appUserCache[data.application_user_id] = data.popinfoID;
        });
      });
    },
    init() {
      this.users = [];
      this.usersCache = [];
      this.appUserCache = [];
      this.paymentMethodCache = [];
      this.usersCsv = [];
      this.key = this.key ? 0 : 1;
      this.loading = true;
    },
    search() {
      if (
        this.conditionsArray.length !== 0 &&
        this.amount !== "" &&
        this.startDate !== "" &&
        this.endDate !== ""
      ) {
        let startYear = this.startDate.split("/")[0];
        let startMonth = this.startDate.split("/")[1];
        let endYear = this.endDate.split("/")[0];
        let endMonth = this.endDate.split("/")[1];
        let endDay = new Date(endYear, endMonth, 0);
        let startDateFormat = new Date(
          startYear + "-" + startMonth + "-01T00:00:00+09:00"
        );
        let endDateFormat = new Date(
          endYear + "-" + endMonth + "-" + endDay.getDate() + "T00:00:00+09:00"
        );
        this.init();
        this.loadCache();
        let usersArray = [];
        let query = this.db.collection("transactions");
        query
          .where("transaction_date_dateformat", ">=", startDateFormat)
          .where("transaction_date_dateformat", "<=", endDateFormat)
          .get()
          .then((snapshot) => {
            snapshot.forEach(async (doc) => {
              let data = doc.data();
              //let sum = 0;
              let valid =
                this.conditionsArray.includes(data.summary_category) &&
                data.format_category !== "01"; // Remove shounin sales
              if (valid) {
                if (usersArray[data.contract_number] == undefined)
                  usersArray[data.contract_number] = 0;
                usersArray[data.contract_number] += parseInt(
                  this.setTextWithCode(
                    data.settlement_operation_code,
                    data.settlement_operation_amount
                  )
                );
              }
            });
            for (let key in usersArray) {
              if (usersArray[key] >= parseInt(this.amount)) {
                let data = this.usersCache[key];
                if (data !== undefined && data.valid_member_flag == "1") {
                  let item = {
                    契約番号: data.contract_number,
                    代表契約番号: data.representative_contract_number,
                    電話番号: data.telephone,
                    携帯電話番号: data.mobile,
                    カナ英字氏名: data.kana_name,
                    漢字氏名: data.kanji_name,
                  };
                  let appUserId = this.paymentMethodCache[data.contract_number];
                  let popinfoId = this.appUserCache[appUserId];
                  if (popinfoId !== undefined) item.POPINFOID = popinfoId;
                  else item.POPINFOID = "";
                  this.users.push(item);
                  this.usersCsv.push({
                    contract_number: data.contract_number,
                    kana_name: data.kana_name,
                    kanji_name: data.kanji_name,
                  });
                }
              }
            }
            sessionStorage.setItem("usersPoints", JSON.stringify(this.users));
            sessionStorage.setItem(
              "usersCsvPoints",
              JSON.stringify(this.usersCsv)
            );
            sessionStorage.setItem(
              "conditions",
              JSON.stringify(this.conditionsArray)
            );
            sessionStorage.startDate = this.startDate;
            sessionStorage.endDate = this.endDate;
            sessionStorage.amount = this.amount;
            sessionStorage.setItem("saved", new Date().getTime());
            this.fileName = "pointUsers";

            this.loading = false;
          });
      }
    },
  },
};
</script>
